import React from 'react';

import NewRankabilityLoader from './NewRankabilityLoader';
import RankabilityLoader from './RankabilityLoader';

const RankabilityLoaderWrapper = ({ optimizerItem, startedStatus = 0 }) => {
    return optimizerItem.is_ai_generated ? (
        <NewRankabilityLoader
            currentProgress={optimizerItem?.queue_progress}
            optimizerStatus={optimizerItem?.queue_status}
        />
    ) : (
        <RankabilityLoader
            percentageStatus={optimizerItem?.queue_progress}
            optimizerStatus={optimizerItem?.queue_status}
            startedStatus={startedStatus}
        />
    );
};

export default RankabilityLoaderWrapper;
